import sumValues from './widget-setting-components/sum-values'

export default [
    {
        name: "Counter Widget",
        schema: {
            fields: [{
                type: 'sum-field-selector',
                name: 'sumField',
                config: {
                    label: {
                        en: 'Sum',
                        de: 'Summieren'
                    },
                    required: true
                }
            },
            {
                type: 'article-type-selector',
                name: 'articleType',
                config: {
                    label: {
                        en: 'Article type',
                        de: 'Artikeltyp'
                    },
                    required: true
                }
            },
            {
                type: 'v-switch',
                name: 'isOnlyContractual',
                config: {
                    label: 'Only contractual',
                    required: true
                }
            },
            {
                type: 'v-switch',
                name: 'isOnlyNotContractual',
                config: {
                    label: 'Only not contractual',
                    required: true
                }
            },
            {
                type: 'v-text-field',
                name: 'eventType',
                config: {
                    label: 'Only count event type',
                    required: false
                }
            },{
                type: 'v-text-field',
                name: 'partnerName',
                config: {
                    label: 'Partner or agency name',
                    required: false
                }
            },
            {
                type: 'v-text-field',
                name: 'shopRefId',
                config: {
                    label: 'Shop Ref Id',
                    required: false
                }
            },
            {
                type: 'event-base-group-selector',
                name: 'eventBaseGroups',
                config: {
                    label: {
                        en: 'Event base groups',
                        de: 'Event-Basis-Gruppen'
                    },
                    required: false
                }
            }]
        },
        config: {
            type: "counter",
            text: {
                caption: {
                    en: "Counter",
                    de: "Zähler"
                }
            },
            data: {
                sumField: null,
                articleType: [],
                isOnlyContractual: false,
                isOnlyNotContractual: false,
                conditions: {
                    wo_status: 2
                }
            },
            layout: {
                x: 0,
                y: 0,
                w: 1,
                h: 3
            }
        },
    },
    // },
    // {
    //     name: "1 Day Widget",
    //     config: {
    //         type: "counter",
    //         text: {
    //             caption: {
    //                 en: "1 day sales",
    //                 de: "Bestellungen pro Saison"
    //             }
    //         },
    //         data: {
    //             isCash: true,
    //             sumField: "Menge",
    //             conditions: {
    //                 wo_status: 2,
    //                 FK_ArticleType: 10
    //             }
    //         },
    //         layout: {
    //             x: 0,
    //             y: 0,
    //             w: 1,
    //             h: 3
    //         }
    //     },
    // },
    // {
    //     name: "2 Day Widget",
    //     config: {
    //         type: "counter",
    //         text: {
    //             caption: {
    //                 en: "2 day sales",
    //                 de: "Bestellungen pro Saison"
    //             }
    //         },
    //         data: {
    //             isCash: true,
    //             sumField: "Menge",
    //             conditions: {
    //                 wo_status: 2,
    //                 FK_ArticleType: 1
    //             }
    //         },
    //         layout: {
    //             x: 0,
    //             y: 0,
    //             w: 1,
    //             h: 3
    //         }
    //     },
    // },
    // {
    //     name: "3 Day Widget",
    //     config: {
    //         type: "counter",
    //         text: {
    //             caption: {
    //                 en: "3 day sales",
    //                 de: "Bestellungen pro Saison"
    //             }
    //         },
    //         data: {
    //             isCash: true,
    //             sumField: "Menge",
    //             conditions: {
    //                 wo_status: 2,
    //                 FK_ArticleType: 2
    //             }
    //         },
    //         layout: {
    //             x: 0,
    //             y: 0,
    //             w: 1,
    //             h: 3
    //         }
    //     },
    // },
    // {
    //     name: "Parking Widget",
    //     config: {
    //         type: "counter",
    //         text: {
    //             caption: {
    //                 en: "Parking sales",
    //                 de: "Bestellungen pro Saison"
    //             }
    //         },
    //         data: {
    //             isCash: true,
    //             sumField: "Menge",
    //             conditions: {
    //                 wo_status: 2,
    //                 FK_ArticleType: 3
    //             }
    //         },
    //         layout: {
    //             x: 0,
    //             y: 0,
    //             w: 1,
    //             h: 3
    //         }
    //     },
    // },
    // {
    //     name: "Coach Widget",
    //     config: {
    //         type: "counter",
    //         text: {
    //             caption: {
    //                 en: "Coach sales",
    //                 de: "Bestellungen pro Saison"
    //             }
    //         },
    //         data: {
    //             isCash: true,
    //             sumField: "Menge",
    //             conditions: {
    //                 wo_status: 2,
    //                 FK_ArticleType: 4
    //             }
    //         },
    //         layout: {
    //             x: 0,
    //             y: 0,
    //             w: 1,
    //             h: 3
    //         }
    //     },
    // },
    // {
    //     name: "Chauffeur Widget",
    //     config: {
    //         type: "counter",
    //         text: {
    //             caption: {
    //                 en: "Chauffeur sales",
    //                 de: "Bestellungen pro Saison"
    //             }
    //         },
    //         data: {
    //             isCash: true,
    //             sumField: "Menge",
    //             conditions: {
    //                 wo_status: 2,
    //                 FK_ArticleType: 5
    //             }
    //         },
    //         layout: {
    //             x: 0,
    //             y: 0,
    //             w: 1,
    //             h: 3
    //         }
    //     },
    // },
    {
        name: "Pie Widget",
        schema: {
            fields: [{
                type: 'sum-field-selector',
                name: 'sumField',
                config: {
                    label: {
                        en: 'Sum',
                        de: 'Summieren'
                    },
                    required: true
                }
            },
            {
                type: 'group-by-selector',
                name: 'groupBy',
                config: {
                    label: {
                        en: 'Group by',
                        de: 'Gruppieren nach'
                    },
                    required: true
                }
            }]
        },
        config: {
            type: "pie-chart",
            text: {
                caption: {
                    en: "Pie chart",
                    de: "Kuchendiagramm"
                }
            },
            data: {
                sumField: null,
                groupBy: 'event_group_name'
            },
            layout: {
                x: 0,
                y: 0,
                w: 2,
                h: 13
            }
        }
    },
    {
        name: "Multi doughnut widget",
        schema: {
            fields: [{
                type: 'sum-field-selector',
                name: 'sumField',
                config: {
                    label: {
                        en: 'Sum',
                        de: 'Summieren'
                    },
                    required: true
                }
            }]
        },
        config: {
            type: "multi-doughnut-chart",
            text: {
                caption: {
                    en: "Dougnut chart",
                    de: "Kreisdiagramm"
                }
            },
            data: {
                sumField: sumValues[0]
            },
            layout: {
                x: 0,
                y: 0,
                w: 2,
                h: 13
            }
        }
    },
    {
        name: "Bar chart Widget",
        schema: {
            fields: [{
                type: 'sum-field-selector',
                name: 'sumField',
                config: {
                    label: {
                        en: 'Sum',
                        de: 'Summieren'
                    },
                    required: true
                }
            },
            {
                type: 'group-by-selector',
                name: 'groupBy',
                config: {
                    label: {
                        en: 'Bar chart',
                        de: 'Balkendiagramm'
                    },
                    required: true
                }
            },
            {
                type: 'partner-select-box',
                name: 'partners',
                config: {
                    label: {
                        en: 'Partners',
                        de: 'Partners'
                    },
                    required: false
                }
            },
            {
                type: 'v-switch',
                name: 'isSplittingContractual',
                config: {
                    label: 'Split contractual',
                    required: true
                }
            },
            {
                type: 'v-switch',
                name: 'isSeasonCompare',
                config: {
                    label: 'Compare with previous season',
                    required: false
                }
            }]
        },
        config: {
            type: "bar-chart",
            text: {
                caption: {
                    en: "Bar sales",
                    de: "Bar pro Saison"
                }
            },
            data: {
                sumField: null,
                groupBy: 'event_group_name'
            },
            layout: {
                x: 0,
                y: 0,
                w: 2,
                h: 13
            }
        }
    },
    {
        name: "Target chart Widget",
        schema: {
            fields: [{
                type: 'sum-field-selector',
                name: 'sumField',
                config: {
                    label: {
                        en: 'Sum',
                        de: 'Summieren'
                    },
                    required: true
                }
            },
            {
                type: 'group-by-selector',
                name: 'groupBy',
                config: {
                    label: {
                        en: 'Bar chart',
                        de: 'Balkendiagramm'
                    },
                    required: true
                }
            },
            {
                type: 'partner-select-box',
                name: 'partners',
                config: {
                    label: {
                        en: 'Partners',
                        de: 'Partners'
                    },
                    required: false
                }
            },
            {
                type: 'v-switch',
                name: 'isSplittingContractual',
                config: {
                    label: 'Split contractual',
                    required: true
                }
            },
            {
                type: 'v-switch',
                name: 'isSeasonCompare',
                config: {
                    label: 'Compare with previous season',
                    required: false
                }
            }]
        },
        config: {
            type: "target-chart",
            text: {
                caption: {
                    en: "Bar sales",
                    de: "Bar pro Saison"
                }
            },
            data: {
                sumField: null,
                groupBy: 'event_group_name'
            },
            layout: {
                x: 0,
                y: 0,
                w: 2,
                h: 13
            }
        }
    },
    {
        name: "Bar Chart Agency",
        schema: {
            fields: [{
                type: 'sum-field-selector',
                name: 'sumField',
                config: {
                    label: {
                        en: 'Sum',
                        de: 'Summieren'
                    },
                    required: true
                }
            },
            {
                type: 'group-by-selector',
                name: 'groupBy',
                config: {
                    label: {
                        en: 'Bar chart',
                        de: 'Balkendiagramm'
                    },
                    required: true
                }
            },
            {
                type: 'partner-select-box',
                name: 'partners',
                config: {
                    label: {
                        en: 'Partners',
                        de: 'Partners'
                    },
                    required: false
                }
            },
            {
                type: 'v-switch',
                name: 'isSplittingContractual',
                config: {
                    label: 'Split contractual',
                    required: true
                }
            },
            {
                type: 'v-switch',
                name: 'isSeasonCompare',
                config: {
                    label: 'Compare with previous season',
                    required: false
                }
            }]
        },
        config: {
            type: "bar-chart-agency",
            text: {
                caption: {
                    en: "Bar sales",
                    de: "Bar pro Saison"
                }
            },
            data: {
                sumField: null,
                groupBy: 'event_group_name'
            },
            layout: {
                x: 0,
                y: 0,
                w: 2,
                h: 13
            }
        }
    },
    {
        name: "Bar Chart Contractual",
        schema: {
            fields: [{
                type: 'sum-field-selector',
                name: 'sumField',
                config: {
                    label: {
                        en: 'Sum',
                        de: 'Summieren'
                    },
                    required: true
                }
            },
            {
                type: 'group-by-selector',
                name: 'groupBy',
                config: {
                    label: {
                        en: 'Bar chart',
                        de: 'Balkendiagramm'
                    },
                    required: true
                }
            },
            {
                type: 'partner-select-box',
                name: 'partners',
                config: {
                    label: {
                        en: 'Partners',
                        de: 'Partners'
                    },
                    required: false
                }
            },
            {
                type: 'v-switch',
                name: 'isSplittingContractual',
                config: {
                    label: 'Split contractual',
                    required: true
                }
            },
            {
                type: 'v-switch',
                name: 'isSeasonCompare',
                config: {
                    label: 'Compare with previous season',
                    required: false
                }
            }]
        },
        config: {
            type: "bar-chart-contractual",
            text: {
                caption: {
                    en: "Bar sales",
                    de: "Bar pro Saison"
                }
            },
            data: {
                sumField: null,
                groupBy: 'event_group_name'
            },
            layout: {
                x: 0,
                y: 0,
                w: 2,
                h: 13
            }
        }
    },
    {
        name: "Target Bar Widget",
        schema: {
            fields: [{
                type: 'sum-field-selector',
                name: 'sumField',
                config: {
                    label: {
                        en: 'Sum',
                        de: 'Summieren'
                    },
                    required: true
                }
            },
            {
                type: 'group-by-selector',
                name: 'groupBy',
                config: {
                    label: {
                        en: 'Bar chart',
                        de: 'Balkendiagramm'
                    },
                    required: true
                }
            },
            {
                type: 'partner-select-box',
                name: 'partners',
                config: {
                    label: {
                        en: 'Partners',
                        de: 'Partners'
                    },
                    required: false
                }
            },
            {
                type: 'v-switch',
                name: 'isSplittingContractual',
                config: {
                    label: 'Split contractual',
                    required: true
                }
            },
            {
                type: 'v-switch',
                name: 'isSeasonCompare',
                config: {
                    label: 'Compare with previous season',
                    required: false
                }
            }]
        },
        config: {
            type: "target-bar",
            text: {
                caption: {
                    en: "Bar sales",
                    de: "Bar pro Saison"
                }
            },
            data: {
                sumField: null,
                groupBy: 'event_group_name'
            },
            layout: {
                x: 0,
                y: 0,
                w: 2,
                h: 13
            }
        }
    },
    {
        name: "Pie Channel Widget",
        schema: {
            fields: [{
                type: 'sum-field-selector',
                name: 'sumField',
                config: {
                    label: {
                        en: 'Sum',
                        de: 'Summieren'
                    },
                    required: true
                }
            },
            {
                type: 'group-by-selector',
                name: 'groupBy',
                config: {
                    label: {
                        en: 'Group by',
                        de: 'Gruppieren nach'
                    },
                    required: true
                }
            }]
        },
        config: {
            type: "pie-chart-channels",
            text: {
                caption: {
                    en: "Pie chart",
                    de: "Kuchendiagramm"
                }
            },
            data: {
                sumField: null,
                groupBy: 'event_group_name'
            },
            layout: {
                x: 0,
                y: 0,
                w: 2,
                h: 13
            }
        }
    },
    {
        name: "HTML Widget",
        schema: {
            fields: [{
                type: 'quill-editor',
                name: 'content',
                config: {
                    label: {
                        de: 'Inhalt',
                        en: 'Content'
                    },
                    required: true
                }
            }]
        },
        config: {
            type: "html-presenter",
            data: {
                content: '<b>Hello world!</b>'
            },
            text: {
                caption: {
                    en: "HTML content",
                    de: "HTML Inhalt"
                },
            },
            layout: {
                x: 0,
                y: 0,
                w: 2,
                h: 13
            }
        }
    },
    {
        name: "Pie Channel Widget Costs",
        schema: {
            fields: [{
                type: 'sum-field-selector',
                name: 'sumField',
                config: {
                    label: {
                        en: 'Sum',
                        de: 'Summieren'
                    },
                    required: true
                }
            },
            {
                type: 'group-by-selector',
                name: 'groupBy',
                config: {
                    label: {
                        en: 'Group by',
                        de: 'Gruppieren nach'
                    },
                    required: true
                }
            }]
        },
        config: {
            type: "pie-chart-channels-cost",
            text: {
                caption: {
                    en: "Pie chart",
                    de: "Kuchendiagramm"
                }
            },
            data: {
                sumField: null,
                groupBy: 'event_group_name'
            },
            layout: {
                x: 0,
                y: 0,
                w: 2,
                h: 13
            }
        }
    },
    {
        name: "Pie Channel Widget Sales",
        schema: {
            fields: [{
                type: 'sum-field-selector',
                name: 'sumField',
                config: {
                    label: {
                        en: 'Sum',
                        de: 'Summieren'
                    },
                    required: true
                }
            },
            {
                type: 'group-by-selector',
                name: 'groupBy',
                config: {
                    label: {
                        en: 'Group by',
                        de: 'Gruppieren nach'
                    },
                    required: true
                }
            }]
        },
        config: {
            type: "pie-chart-channels-sales",
            text: {
                caption: {
                    en: "Pie chart",
                    de: "Kuchendiagramm"
                }
            },
            data: {
                sumField: null,
                groupBy: 'event_group_name'
            },
            layout: {
                x: 0,
                y: 0,
                w: 2,
                h: 13
            }
        }
    },
    {
        name: "Pie Channel Widget Arrangement Fee",
        schema: {
            fields: [{
                type: 'sum-field-selector',
                name: 'sumField',
                config: {
                    label: {
                        en: 'Sum',
                        de: 'Summieren'
                    },
                    required: true
                }
            },
            {
                type: 'group-by-selector',
                name: 'groupBy',
                config: {
                    label: {
                        en: 'Group by',
                        de: 'Gruppieren nach'
                    },
                    required: true
                }
            }]
        },
        config: {
            type: "pie-chart-channels-arrangement-fee",
            text: {
                caption: {
                    en: "Pie chart",
                    de: "Kuchendiagramm"
                }
            },
            data: {
                sumField: null,
                groupBy: 'event_group_name'
            },
            layout: {
                x: 0,
                y: 0,
                w: 2,
                h: 13
            }
        }
    }
]